import { useMemo, useState } from "react";
import { FEEDS, type FeedItem } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const TABS = ["全部", "猛料", "黑料", "内幕", "曝光"];

const toneCls: Record<string, string> = {
  hot: "bg-primary-600 text-background-50",
  gold: "bg-accent-500 text-foreground-950",
  ink: "bg-secondary-900 text-background-50",
};

export default function Feed() {
  const [active, setActive] = useState("全部");

  const list = useMemo<FeedItem[]>(() => {
    if (active === "全部") return FEEDS;
    const matched = FEEDS.filter((f) => f.tag === active);
    return matched.length ? matched : FEEDS;
  }, [active]);

  return (
    <section id="feed" className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="黑料猛料现场 · 图文并重"
          title="猛料与黑料，正在一张张流出来"
          desc="大图直给、信息量大，一条接一条不换气地刷，适合蹲瓜的人。"
          extra={
            <div className="inline-flex rounded-full bg-background-100 p-1">
              {TABS.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => setActive(t)}
                  className={`whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] font-semibold transition-colors ${
                    active === t ? "bg-primary-600 text-background-50" : "text-foreground-600 hover:text-primary-600"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((f) => (
            <article
              key={f.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-1"
            >
              <a href="#report" className="relative block overflow-hidden">
                <img
                  src={f.img}
                  alt={`${f.tag} ${f.title}`}
                  className="h-[180px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded px-2 py-0.5 text-[12px] font-bold ${toneCls[f.tagTone]}`}
                >
                  {f.tag}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded bg-foreground-950/55 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur">
                  <i className="ri-fire-fill w-3.5 h-3.5 flex items-center justify-center" />
                  {f.reads}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h4 className="font-heading text-[16px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  <a href="#report">{f.title}</a>
                </h4>
                <p className="mt-2 line-clamp-2 flex-1 text-[13px] leading-6 text-foreground-600">{f.summary}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-[12px] text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    {f.reads}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center" />
                    {f.comments.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
                    {f.time}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="#feed"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-6 py-2.5 text-[14px] font-semibold text-secondary-800 transition-colors hover:bg-secondary-50"
          >
            <i className="ri-refresh-line w-4 h-4 flex items-center justify-center" />
            换一拨瓜 · 加载更多
          </a>
        </div>
      </div>
    </section>
  );
}